/**
 * Language Select Component
 */
import React from "react"
import {
  Trigger,
  Separator,
  IconWrapper,
  Wrapper,
  DisplayFlex,
  Link,
  DropDownWrapper,
  Title,
  UL,
  LI,
} from "./styles"
import Icon from "components/Icon"
import { getQueryParameters } from "utils/utils"
import { ENGLISH_LANGUAGE_CODE } from "utils/constants"
import Translate from "components/Translate/container"
import { goToLanguageSite } from "utils/languageUtils"

export class LanguageSelect extends React.Component {
  state = {
    showDropdown: false,
  }

  toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown })
  }

  render() {
    const { showDropdown } = this.state
    const { languages } = this.props
    const query = getQueryParameters()
    const selectedLanguage = languages.find(
      x => x.id === (query.language ? query.language : ENGLISH_LANGUAGE_CODE)
    )

    return (
      <Wrapper>
        <DisplayFlex>
          <Trigger onClick={this.toggleDropdown}>
            <IconWrapper>
              <Icon variant={"globe"} />
            </IconWrapper>
            <Link>
              <Translate>{selectedLanguage?.name}</Translate>
            </Link>
          </Trigger>
          <Separator>|</Separator>
        </DisplayFlex>

        <DropDownWrapper showDropdown={showDropdown}>
          <Title>
            <Translate>Change language</Translate>
          </Title>
          <UL>
            {languages?.map(language => (
              <LI onClick={e => goToLanguageSite(language)} key={language.id}>
                <Translate>{language.name}</Translate>
              </LI>
            ))}
          </UL>
        </DropDownWrapper>
      </Wrapper>
    )
  }
}

export default LanguageSelect
